import { notifications, NotificationData } from "@mantine/notifications";

const position = window.innerWidth <= 665 ? "top-center" : "bottom-right";

export function successNotification(props: NotificationData) {
  const { title, message, ...rest } = props;
  cleanNotifications();
  return notifications.show({
    title: title ?? undefined,
    color: "#004a99",
    message,
    position,
    ...rest,
  });
}

export function errorNotification(props: NotificationData) {
  const { title, message, ...rest } = props;
  cleanNotifications();
  return notifications.show({
    title: title ?? "Greška",
    color: "red",
    message,
    position,
    ...rest,
  });
}

export function cleanNotifications() {
  notifications.clean();
}
